import { render, staticRenderFns } from "./GamesWrapper.vue?vue&type=template&id=11919822&scoped=true&lang=pug&"
import script from "./GamesWrapper.vue?vue&type=script&lang=js&"
export * from "./GamesWrapper.vue?vue&type=script&lang=js&"
import style0 from "./GamesWrapper.vue?vue&type=style&index=0&id=11919822&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11919822",
  null
  
)

export default component.exports